"use strict";

module.exports = {
  HIGH: 'HIGH',
  LOW: 'LOW'
};